module.exports = __webpack_public_path__ + "img/user-slash.da91be94.svg";